import { render } from "./AddDataKeluarga.vue?vue&type=template&id=fe0d2e72"
import script from "./AddDataKeluarga.vue?vue&type=script&lang=js"
export * from "./AddDataKeluarga.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__